import React from "react";

import {useExpansionRegistryContext} from "../components_v2/Registry";

function useExpandedWithRegistry(id, defaultExpanded=true) {
  const expansionRegistry = useExpansionRegistryContext();

  const [expanded, setExpanded] = React.useState(() => {
    let expandedFromRegistry = expansionRegistry ? expansionRegistry.get(id) : undefined;

    return typeof expandedFromRegistry === 'boolean' ? expandedFromRegistry : defaultExpanded;
  });

  React.useEffect(() => {
    if (expansionRegistry) {
      expansionRegistry.set(id, expanded);
    }
  }, [id, expanded, expansionRegistry]);

  return [expanded, setExpanded];
}

export default useExpandedWithRegistry;